<script>
import './stylesheets/components/VsTable';

import $ from 'domtastic';
import each from 'lodash/each';

import VsLayout from './VsLayout';
import VsTableHeader from './VsTableHeader';
import vueMixins from './vueMixins';

export default {
  components: {
    VsLayout,
    VsTableHeader,
  },
  mixins: [vueMixins],
  props: {
    processing: Boolean,
    headings: Array,
    small: [String, Boolean],
    isLarge: [String, Boolean],
    sortColumn: String,
    sortDirection: Number,
    selectable: [String, Boolean],
    respondLg: [String, Boolean],
    respondXl: [String, Boolean],
    notResponsive: [String, Boolean],
    notSticky: [String, Boolean],
  },
  data: () => ({
    headerTop: 0,
  }),
  computed: {
    classes() {
      return {
        'vs-table--large': this.isLarge,
        'vs-table--small': this.small,
        'vs-table--selectable': this.selectable,
        'vs-table--respond-lg': this.respondLg,
        'vs-table--respond-xl': this.respondXl,
        'vs-table--not-responsive': this.notResponsive,
      }
    },
  },
  mounted() {
    this.$_initControls();

    $(window).on('resize', this.$_initControls);
  },
  beforeDestroy() {
    $(window).off('resize', this.$_initControls);
  },
  methods: {
    $_initControls() {
      this.headerTop = document.querySelector('.vs-table__controls-container').offsetHeight
    },
    handleTableSort(property) {
      if (!this.processing) {
        this.$emit('sort', property);
      }
    },
    handleHeaderAction(action) {
      this.$emit(action);
    },
  },
};
</script>

<template lang='pug'>
.vs-table(:class='classes')
  vs-table-header.z-10.bg-white(
    ref='header',
    :class='{ sticky: !notSticky }',
    :processing='processing',
    :headings='headings',
    :sort-column='sortColumn',
    :sort-direction='sortDirection',
    :header-top='headerTop',
    @sort='handleTableSort',
    @header-action='handleHeaderAction',
    @help='$emit("help")',
  )
  .vs-table__body
    slot
</template>